import { render, staticRenderFns } from "./Audiogram.vue?vue&type=template&id=6b0eccfe&"
import script from "./Audiogram.vue?vue&type=script&lang=js&"
export * from "./Audiogram.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports